


import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AdminHeader = () => {
    const navigate = useNavigate();
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false); // State for mobile menu

    const toggleProfileDropdown = () => {
        setShowProfileDropdown(!showProfileDropdown);
    };

    const handleLogout = () => {
        navigate('/');
    };

    const handleProfileClick = () => {
        navigate('/admin/profile');
        setShowProfileDropdown(false);
    };

    const handleChangePasswordClick = () => {
        navigate('/changepassword');
        setShowProfileDropdown(false);
    };

    const handleProductCustomersClick = () => {
        navigate('/customers');
        setShowProfileDropdown(false);
    };

    const handleCategoryClick = () => {
        navigate('/category');
        setShowProfileDropdown(false);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2">
            <div className="container">
                
                {/* BRAND LOGO */}
                <Link className="navbar-brand d-flex align-items-center" to="/admin/dashboard" style={{ maxWidth: '65%' }}>
                    <svg
                        width="42"
                        height="42"
                        viewBox="0 0 180 120"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginRight: '5px' }}
                    >
                        <text x="0" y="90" fontFamily="Playfair Display, Didot, serif" fontSize="96" fontWeight="700" letterSpacing="-10" fill="#111">MF</text>
                    </svg>

                    <div className="d-flex flex-column">
                        <span style={{ fontSize: '0.95rem', fontWeight: '500', letterSpacing: '0.3rem', color: '#111', lineHeight: '1.1' }}>MUNNY FINDS</span>
                        <span style={{ fontSize: '0.5rem', letterSpacing: '0.2rem', fontWeight: '600', color: '#6b7280', marginTop: '1px' }}>ADMIN CONTROL</span>
                    </div>
                </Link>

                {/* Right side container for Profile and Toggler */}
                <div className="d-flex align-items-center gap-1 order-lg-last">
                    {/* Profile Dropdown */}
                    <div className="dropdown position-relative">
                        <button 
                            className="btn d-flex align-items-center gap-1 border-0 bg-transparent p-1"
                            onClick={toggleProfileDropdown}
                        >
                            <div className="rounded-circle overflow-hidden" 
                                 style={{ width: '35px', height: '35px', backgroundColor: '#065f46' }}>
                                <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                                    <i className="ri-user-line text-white fs-6"></i>
                                </div>
                            </div>
                            <span className="fw-semibold text-dark d-none d-md-inline ms-1" style={{ fontSize: '0.9rem' }}>Admin</span>
                            <i className={`ri-arrow-down-s-line small ${showProfileDropdown ? 'rotate-180' : ''}`}></i>
                        </button>
                        
                        {showProfileDropdown && (
                            <>
                                <div className="position-fixed top-0 start-0 w-100 h-100" onClick={() => setShowProfileDropdown(false)} style={{ zIndex: 1040 }}></div>
                                <div className="dropdown-menu show position-absolute end-0 mt-2 border-0 shadow-lg rounded-3" style={{ minWidth: '220px', zIndex: 1050, backgroundColor: '#fff' }}>
                                    <div className="px-3 py-3 border-bottom">
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: '#065f46' }}>
                                                <i className="ri-user-line text-white fs-5"></i>
                                            </div>
                                            <div>
                                                <h6 className="mb-0 fw-bold" style={{ fontSize: '0.85rem' }}>Admin User</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="py-2">
                                        <button className="dropdown-item py-2 px-3" onClick={handleProfileClick}><i className="ri-user-line me-2 text-primary"></i> My Profile</button>
                                        <button className="dropdown-item py-2 px-3" onClick={handleChangePasswordClick}><i className="ri-lock-line me-2 text-primary"></i> Password</button>
                                        
                                        <button className="dropdown-item py-2 px-3" onClick={handleCategoryClick}><i className="ri-list-check-2 me-2 text-primary"></i> Categories</button>
                                        <div className="dropdown-divider"></div>
                                        <button className="dropdown-item py-2 px-3 text-danger" onClick={handleLogout}><i className="ri-logout-box-r-line me-2"></i> Logout</button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Mobile Toggler */}
                    <button 
                        className="navbar-toggler border-0 p-1 ms-1" 
                        type="button" 
                        onClick={() => setIsNavOpen(!isNavOpen)}
                    >
                        <span className="navbar-toggler-icon" style={{ width: '1.2em', height: '1.2em' }}></span>
                    </button>
                </div>

                {/* Nav Links */}
                <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="adminNavbar">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-2 pt-3 pt-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/admin/dashboard" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-dashboard-line me-2 d-lg-none"></i> Dashboard
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/salons" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-store-2-line me-2 d-lg-none"></i> Salons
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/appointments" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-calendar-check-line me-2 d-lg-none"></i> Appointments
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/services" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-customer-service-2-line me-2 d-lg-none"></i> Services
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/Product" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-shopping-bag-line me-2 d-lg-none"></i> Products
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/orders" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-file-list-3-line me-2 d-lg-none"></i> Orders
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <style>{`
                .rotate-180 { transform: rotate(180deg); transition: transform 0.3s ease; }
                .dropdown-item:hover { background-color: #f8f9fa; color: #065f46; }
                @media (max-width: 991px) {
                    .navbar-collapse.show {
                        display: block;
                        background: white;
                        border-top: 1px solid #eee;
                        padding-bottom: 15px;
                    }
                    .nav-item { border-bottom: 1px solid #f9f9f9; }
                    .nav-link { padding: 12px 10px !important; }
                }
            `}</style>
        </nav>
    );
};

export default AdminHeader;